<nz-layout>
    <nz-header class="d-flex align-items-center notPrintable">
        <div class="logo">
            <a href="bade-loft/dashboard">
                <img class="header-logo" src="../../../assets/images/logo.png">
            </a>
        </div>
        <div class="menu-box d-flex">
            <div class="order-3 d-flex align-items-center welcomeuser-group">
                <div class="welcomeuser">
                    <a class="nav-link d-flex align-items-center">
                        <div><a routerLink="/bade-loft/logs"><span nz-icon nzType="setting" nzTheme="outline"></span></a>
                    </div>
                        <!-- <img src="./assets/images/user.png" class="img-fluid"> -->
                        <div class="username-box pl-3">
                            <small class="welcome-text">Welcome</small>
                            <h6 class="user-name">{{userInfoObj.firstName + ' ' + userInfoObj.lastName}}</h6>
                        </div>
                    </a>
                </div>
                <div class="loginicon">
                    <a (click)="logOut()" class="log-out-link">
                        <img src="./assets/images/Log-Out.svg" class="img-fluid">
                    </a>
                </div>
            </div>
            <div class="mobile-icon">
                <a class="menu-icon"><i nz-icon nzType="menu" nzTheme="outline"></i></a>
            </div>
            <div class="nav-menu">
                <div class="menu-close-box">
                    <a class="mobile-close-icon">
                        <img class="close-icon" src="./assets/images/Close.svg">
                    </a>
                </div>
                <ul nz-menu nzMode="horizontal">
                    <li nz-menu-item routerLink="/bade-loft/dashboard" [nzSelected]="currentUrl.includes('dashboard')">
                        <a>
                            Dashboard</a>
                    </li>
                    <li nz-menu-item routerLink="/bade-loft/stock" [nzSelected]="currentUrl.includes('stock')"><a>
                            Stock</a>
                    </li>
                    <li nz-menu-item routerLink="/bade-loft/warehouse" [nzSelected]="currentUrl.includes('warehouse')">
                        <a>
                            Warehouse</a>
                    </li>
                    <li nz-menu-item routerLink="/bade-loft/assignment"
                        [nzSelected]="currentUrl.includes('assignment')">
                        <a>Assignment</a>
                    </li>
                    <li nz-menu-item [nzSelected]="currentUrl.includes('status')" style="position: relative;"
                        class="lastLi">
                        <a routerLink="/bade-loft/status"
                            (click)="this._cS.incompleteStatusRecords.next(null);">Status</a>
                        <span class="badge cursor" *ngIf="incompleteStatusCount > 0"
                            (click)="navigateToStatus()">{{incompleteStatusCount}}</span>
                    </li>
                    <li nz-menu-item [nzSelected]="currentUrl.includes('orders')" routerLink="/bade-loft/orders">
                        <a>Orders</a>
                    </li>
                    <li nz-menu-item [nzSelected]="currentUrl.includes('shipped')" routerLink="/bade-loft/shipped">
                        <a>Shipped</a>
                    </li>
                    <li nz-menu-item [nzSelected]="currentUrl.includes('return')" routerLink="/bade-loft/return">
                        <a>Return</a>
                    </li>
                </ul>
            </div>
        </div>
    </nz-header>
    <nz-layout>
        <nz-sider nzTheme="light"
            *ngIf="currentUrl.includes('logs') || currentUrl.includes('connection') || currentUrl.includes('sync-dashboard')">
            <div>
                <ul nz-menu nzMode="inline">
                    <li nz-menu-item [nzSelected]="currentUrl.includes('logs')"><a
                            [routerLink]="'/bade-loft/logs'">Integration Status</a></li>
                    <li nz-menu-item [nzSelected]="currentUrl.includes('sync-dashboard')"><a
                            [routerLink]="'/bade-loft/sync-dashboard'">Sync Dashboard</a></li>
                    <li nz-menu-item [nzSelected]="currentUrl.includes('connection') && !currentUrl.includes('shopify')"><a
                            [routerLink]="'/bade-loft/connection'">Connection Status</a>
                    </li>
                    <li nz-menu-item [nzSelected]="currentUrl.includes('shopify-connection')"><a
                            [routerLink]="'/bade-loft/shopify-connection'">Shopify Connection</a>
                    </li>
                </ul>
            </div>
        </nz-sider>
        <nz-layout>
            <nz-content class="overflow-y">
                <nz-spin [nzSpinning]="_cS.isSpinning" nzTip="Loading...">
                    <router-outlet></router-outlet>
                </nz-spin>
            </nz-content>
        </nz-layout>
        <!-- <nz-footer>Ant Design ©2020 Implement B y Angular</nz-footer> -->
    </nz-layout>
</nz-layout>